import './_active-filters.scss';

export default () => {};
